import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BalanceAccountService {
  constructor(private readonly http: HttpClient) { }


  createNewBalanceAccount(payload: any) {
    let url = environment.BASE_URL + '/v1/balance-accounts';
    return this.http.post(url, payload);
  }

  editBalanceAccount(id: string, payload: any) {
    let url = environment.BASE_URL + `/v1/balance-accounts/${id}`;
    return this.http.put(url, payload);
  }

  getBalanceAccounts(payload: any) {
    let url = environment.BASE_URL + '/v1/balance-accounts';
    return this.http.get(url, { params: payload })
  }

  getBalanceAccountsSummary(payload: any) {
    let url = environment.BASE_URL + '/v1/balance-accounts/stats';
    return this.http.get(url, { params: payload })
  }

}
